import { useCallback, useMemo, useState } from "react"

import { useTranslation } from "@l2r-front/l2r-i18n"
import { MenuIcon } from "@l2r-front/l2r-icons"

import { AccountSettingsMobileLayout } from "../../../modules/accountSettings/layouts/AccountSettingsLayout/AccountSettingsMobileLayout"
import { AccountSettingsEmailPage } from "../../../modules/accountSettings/pages/AccountSettingsEmailPage"
import { AccountSettingsPasswordPage } from "../../../modules/accountSettings/pages/AccountSettingsPasswordPage"
import { AccountSettingsProfilePage } from "../../../modules/accountSettings/pages/AccountSettingsProfilePage"
import { MobileAccountSettingsHomePage } from "../../../modules/accountSettings/pages/MobileAccountSettingsHomePage"
import { MobileSettingsMainPage } from "../../../modules/accountSettings/pages/MobileSettingsMainPage"
import { I18N_NAMESPACE } from "../../constants/i18n"
import { ACCOUNT_PAGE, EMAIL_PAGE, MAIN_PAGE, PARAMETERS_PAGE, PASSWORD_PAGE } from "../../constants/settings"

import * as Styled from "./BurgerMenu.styled"

export const BurgerMenu = () => {
    const [open, setOpen] = useState(false)
    const [page, setPage] = useState(MAIN_PAGE)

    const { t } = useTranslation(I18N_NAMESPACE)

    const handleClose = useCallback(() => {
        setPage(MAIN_PAGE)
        setOpen(false)
    }, [])

    const parametersInfos = useMemo(() => {
        switch (page) {
            case PARAMETERS_PAGE:
                return {
                    title: t(I18N_NAMESPACE, "pages.accountSettings.parameters"),
                    previousPage: MAIN_PAGE,
                    component: <MobileAccountSettingsHomePage changePage={setPage} />,
                }
            case ACCOUNT_PAGE:
                return {
                    title: t(I18N_NAMESPACE, "pages.accountSettings.profile.accountInfoLabel"),
                    previousPage: PARAMETERS_PAGE,
                    component: <AccountSettingsProfilePage onSuccess={() => setPage(PARAMETERS_PAGE)} />,
                }
            case EMAIL_PAGE:
                return {
                    title: t(I18N_NAMESPACE, "pages.accountSettings.profile.accountEmailLabel"),
                    previousPage: PARAMETERS_PAGE,
                    component: <AccountSettingsEmailPage onSuccess={() => setPage(PARAMETERS_PAGE)} />,
                }
            case PASSWORD_PAGE:
                return {
                    title: t(I18N_NAMESPACE, "pages.accountSettings.profile.accountPasswordLabel"),
                    previousPage: PARAMETERS_PAGE,
                    component: <AccountSettingsPasswordPage onSuccess={() => setPage(PARAMETERS_PAGE)} />,
                }
            default:
                return
        }
    }, [page, t])

    if (!open) {
        return <Styled.FabButton
            variant="tertiary"
            shape="circle"
            id="map-legend-open-button"
            onClick={() => setOpen(true)}
        >
            <MenuIcon />
        </Styled.FabButton>
    }

    return <Styled.Popup open={open} hideBackdrop>
        <Styled.Box>
            {page === MAIN_PAGE && <MobileSettingsMainPage onClose={handleClose} changePage={setPage} />}
            {page !== MAIN_PAGE && <AccountSettingsMobileLayout title={parametersInfos.title} onBack={() => setPage(parametersInfos.previousPage)}>
                {parametersInfos.component}
            </AccountSettingsMobileLayout>}
        </Styled.Box>
    </Styled.Popup>
}